import {
  AirplaneLandingFilled,
  AirplaneTakeOffFilled,
} from "@fluentui/react-icons";
import { FlightLegTypeEnum } from "../../../enum/FlightsEnum";

export interface IFlightIconSelectorProps {
  legType?: string;
}

export default function FlightIconSelector({
  legType = FlightLegTypeEnum.Arrival,
}: IFlightIconSelectorProps) {
  return (
    <div className={"fs-20"} data-testid="flight-icon-selector">
      {legType === FlightLegTypeEnum.Arrival ? (
        <AirplaneLandingFilled />
      ) : (
        <AirplaneTakeOffFilled />
      )}
    </div>
  );
}
